import * as React from "react";
import type { SVGProps } from "react";
const SvgIconReply = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.3 1.6c-.19.04-.06-.09-2.94 2.8C1.87 5.88.64 7.13.62 7.17c-.14.21-.11.48.06.68.14.17 5.33 5.87 5.37 5.9q.14.12.33.12c.11 0 .16 0 .23-.03.12-.04.25-.16.31-.28l.05-.1V10.7h.51c1.1 0 1.69.05 2.2.18.73.18 1.28.45 2 .99.38.28.77.61 1.83 1.53 1 .87 1.05.92 1.13.96.37.18.8-.06.83-.47 0-.1 0-.13-.05-.29-.58-1.84-.72-2.26-.92-2.82-.67-1.86-1.43-3.18-2.38-4.13Q10.5 5 8.1 4.8l-.66-.02-.46-.02V3.42c0-1.42 0-1.42-.08-1.54-.08-.14-.23-.25-.36-.27s-.15-.02-.23 0M3.87 5.52 1.9 7.5l.03.04L3.9 9.7l1.93 2.13.01-.93v-.92l.05-.1q.1-.18.28-.28l.1-.04h1c1.48-.01 2 .03 2.69.2 1.13.27 1.96.76 3.4 2l.36.29-.38-1.13q-.8-2.16-1.87-3.31-.97-1.05-2.27-1.45c-.62-.19-1.09-.24-2.14-.24-.78 0-.83 0-.97-.1q-.14-.1-.2-.25c-.04-.07-.04-.09-.05-1.04v-.98z"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconReply;
